/**
 * Normalize display names for BRAI-785 roster merge.
 *
 * Waiting / "In this room" match share rows to WS members by name only
 * (WS roster has no userId). Trim + lowercase keeps obvious casing drift
 * from flipping someone between Invited and Active incorrectly.
 */
export function normalizeMemberName(name: string): string {
  return name.trim().toLowerCase()
}
